async function translateTextInElement(el) {
  if (!el || !el.textContent.trim() ) return;

  const originalText = el.textContent.trim();

  try {
    const res = await fetch('https://olfa-bv-translation-vercel.vercel.app/api/translate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        q: originalText,
        source: 'en',
        target: 'fr',
      }),
    });

    const data = await res.json();
    if (data.translatedText) {
      el.textContent = data.translatedText;
    }

  } catch (err) {
    console.error('Translation error:', err);
  }
}

function translateReview(parent) {
  const el = parent.querySelector('.kl_reviews__review__content');
  if (!el) return;
  return () => translateTextInElement(el);
}

function translateDate(parent) {
  const el = parent.querySelector('.kl_reviews__review_stars_and_time .kl_reviews__time_badge .kl_reviews__review__timestamp');
  if (!el) return;
  return () => translateTextInElement(el);
}

function translateResponse(parent) {
  const el = parent.querySelector('.kl_reviews__review__response p.kl_reviews__review__response_content');
  if (!el) return;
  return () => translateTextInElement(el);
}

async function handleTranslationClick(button, parent) {
  button.disabled = true;
  button.textContent = 'Traduction en cours...';

  const reviewFn = translateReview(parent);
  const dateFn = translateDate(parent);
  const responseFn = translateResponse(parent);

  await Promise.all([
    reviewFn?.(),
    dateFn?.(),
    responseFn?.()
  ]);

  button.textContent = 'Traduit';
  
}

function addTranslateButtons() {
  const reviews = document.querySelectorAll('.kl_reviews__list .kl_reviews__review_item');  

  if (reviews.length === 0) return;

  for (let i = 0; i < reviews.length; i++) {
    const target = reviews[i];

    if (!target) continue;

    const existingBtn = target.querySelector('.traducir-btn');

    if (!existingBtn) {

      const button = document.createElement('button');
      button.className = 'traducir-btn';
      button.textContent = 'Traduire avec Google';
      button.style.marginTop = '20px';

      button.addEventListener('click', () => handleTranslationClick(button, target));

      const buttonContainer = document.createElement('div');
      buttonContainer.className = 'traducir-btn-container';
      buttonContainer.appendChild(button);

      target.appendChild(buttonContainer);
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/fr/')) return;  
  
  const reviewsRoot = document.getElementById('fulfilled-reviews-all');

  if (reviewsRoot) {
    const waitForInitialLoad = new MutationObserver(() => {
      const reviewsContainer = reviewsRoot.querySelector('.kl_reviews__list');
      if (reviewsContainer && reviewsContainer.children.length > 0) {
        addTranslateButtons();

        const observer = new MutationObserver(() => {
          setTimeout(addTranslateButtons, 100);
        });

        observer.observe(reviewsContainer, { childList: true, subtree: true });
        waitForInitialLoad.disconnect();
      }
    });

    waitForInitialLoad.observe(reviewsRoot, { childList: true, subtree: true });
  }
});
